
import TiwiMixin from '../mixins/TiwiMixin';

export default {
  mixins: [TiwiMixin],
  props: {
    count: {
      required: false,
      default: 0,
      type: Number
    },
    linkOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    post: {
      type: Object,
      required: false,
      default: null
    },
    iconClass: {
      type: String,
      required: false,
      default: ''
    },
  },
  data() {
    return {
      current_count: this.count
    }
  },
  methods: {
    openCommentModal: function () {
      this.setCommentablePost(this.post);
    },
  },
}
